import { render, staticRenderFns } from "./ChildSubMenuItem.vue?vue&type=template&id=a204f10e"
import script from "./ChildSubMenuItem.vue?vue&type=script&lang=js"
export * from "./ChildSubMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports